import { render, staticRenderFns } from "./paymentez.vue?vue&type=template&id=4e55b853&scoped=true&"
import script from "./paymentez.vue?vue&type=script&lang=js&"
export * from "./paymentez.vue?vue&type=script&lang=js&"
import style0 from "./paymentez.vue?vue&type=style&index=0&id=4e55b853&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e55b853",
  null
  
)

export default component.exports